import { Component, Input, NgZone, OnInit } from '@angular/core';
import { State } from '../../../shared/interface/state.interface';
import { PurchaseFlow } from '../../common/enumerations';
import { MemberTypeEnum } from '../../enums/member-type.enum';
import { OrderSourceTypes, OrderSourceValue } from '../../enums/order-source.enum';
import { PaymentProcessorAlias } from '../../enums/payment-processor-alias.enum';
import { PaymentStatus } from '../../enums/payment-status.enum';
import { PosPaymentGroupEnum } from '../../enums/pos-payment-group.enum';
import { PayvisionBillingAddress, PayvisionMandatoryBillingAddressFields } from '../../interface/payvision-billingaddress.interface';
import { PaymentRegistrationResponse } from '../../interface/payvision/payment-registration-reponse.interface';
import { PayvisionRegistration } from '../../interface/payvision/payvision-registration.interface';
import { PaymentComponentSettings } from '../../models/payments/payment.model';
import { CustomerService } from '../../services/customer.service';
import { PayvisionService } from '../../services/payvision.service';

@Component({
    selector: 'payment-payvision',
    templateUrl: '../../templates/template1/views/payments/payvision.component.html',
    styleUrls: []
})

export class PayvisionComponent implements OnInit {
    @Input() paymentComponentSettings: PaymentComponentSettings;
    posPaymentGroupEnum = PosPaymentGroupEnum;
    states: State[] = [];
    constructor(
        private _payvisionService: PayvisionService,
        private _customerService: CustomerService,
        private zone: NgZone) { }

    ngOnInit(): void {
        this.loadDefaultSettings();
    }
     /**
 * @description Load Default shipping Settings
 * for the member
 * @date 2018-08-30
 * @memberof PayvisionComponent
 */
loadDefaultSettings() {
    this.getStates();
}

getStates() {
    this._customerService.getStates().subscribe(response => {
        if (response) {
            this.states = response;
            this.getPavisionPaymentForm();
        } else {
            this.getPavisionPaymentForm();
        }
    } , (error: any) => {
        this.getPavisionPaymentForm();
    });
}
    /**
     * @description to get the Payment form
     * @date 2018-08-27
     * @memberof PayvisionComponent
     */
    getPavisionPaymentForm(): void {
        this._payvisionService
             .getPayvisionForm(this.paymentComponentSettings.storeId, this.payvisionRegistration())
            .subscribe((response: PaymentRegistrationResponse) => {
                this.loadPayvisionForm(response);
            });
    }

/**
     * @description preparing the Payvision Registration
     * @date 2018-08-30
     * @returns {PayvisionRegistration}
     * @memberof PayvisionComponent
     */
    payvisionRegistration(): PayvisionRegistration {
        const payvisionRegistration: PayvisionRegistration = {
            portalCsp: true,
            countryCode: this.paymentComponentSettings.isoCountryCode.toUpperCase(),
            customerId: this.paymentComponentSettings.memberId ? (+this.paymentComponentSettings.memberId):0,
            storeId: this.paymentComponentSettings.storeId,
             orderSourceTypeId: (this.paymentComponentSettings.webOrderId && this.paymentComponentSettings.orderType === OrderSourceTypes.POS)?
                                     OrderSourceValue.POS : OrderSourceValue.CUSTOMER,                        
            orderTypeId: (this.paymentComponentSettings.webOrderId && this.paymentComponentSettings.orderType === OrderSourceTypes.POS)?
                               this.getOrderTypeId():this.paymentComponentSettings.memberTypeId,
            paymentMethodType: this.paymentComponentSettings.paymentMethodTypes.Credit_Card,
            currencyCode: this.paymentComponentSettings.currencyCode,
            orderReferenceId: this.paymentComponentSettings.orderReferenceId,
            amount: this.paymentComponentSettings.amount,
            paymentGroupId: this.paymentComponentSettings.webOrderId?this.posPaymentGroupEnum.Integrated_Payments:null,
            paymentRequestModel: {
                createRegistartion: this.paymentComponentSettings.webOrderId && this.paymentComponentSettings.orderType=== OrderSourceTypes.POS? false : true,
                webOrderId: (this.paymentComponentSettings.webOrderId && this.paymentComponentSettings.orderType=== OrderSourceTypes.POS) ?
                                this.paymentComponentSettings.webOrderId :null
            },
            paymentCallBackUrlModel: {
                webOrderId:(this.paymentComponentSettings.webOrderId && this.paymentComponentSettings.orderType === OrderSourceTypes.POS) ?
                                      this.paymentComponentSettings.webOrderId :null,
                cancelledUrl: this.getCurrentWindowUrl() + PaymentStatus.CANCELLED.toLowerCase(),
                failureUrl: this.getCurrentWindowUrl() + PaymentStatus.FAILED.toLowerCase(),
                successUrl: this.getCurrentWindowUrl() + PaymentStatus.SUCCESS.toLowerCase(),
                orderSourceTypeId: (this.paymentComponentSettings.webOrderId && this.paymentComponentSettings.orderType === OrderSourceTypes.POS) ?
                                      OrderSourceValue.POS:OrderSourceValue.CUSTOMER,
            },
        };
        return payvisionRegistration;

    }
    /**
     * @description this method will return current window url
     * @date 2018-08-30
     * @private
     * @returns {string}
     * @memberof PayvisionComponent
     */
    private getCurrentWindowUrl(): string {
        const routeUrl = window.location.href.includes('posorders') ? '/customerservice/posorders/' : '/customerservice/orders/';
        const currentWindowURL: string = window.location.origin + routeUrl
        + PaymentProcessorAlias.PAYVISION.toLowerCase() + '/';
        return currentWindowURL;
    }
/**
     * @description to load the Payvision Merchant Determined
     * Registration Checkout form
     * @date 2018-08-27
     * @param {PaymentRegistrationResponse} registrationResponse
     * @memberof PayvisionComponent
     */
    loadPayvisionForm(registrationResponse: PaymentRegistrationResponse): void {
        if (registrationResponse && registrationResponse.id) {
            const scriptSrc = registrationResponse.formUrl;
            window['wpwlOptions'] = this.getPayvisionOptions();
            const payvisionScript = document.createElement('script');
            payvisionScript.src = decodeURIComponent(encodeURIComponent(scriptSrc + '?checkoutId=' + registrationResponse.id));
            payvisionScript.type = 'text/javascript';
            document.head.appendChild(payvisionScript);
            const payvisionForm = document.createElement('form');
            payvisionForm.setAttribute('action', decodeURIComponent(encodeURIComponent(registrationResponse.paymentUrl)));
            payvisionForm.setAttribute('class', 'paymentWidgets');
            if (registrationResponse.cardBrands && registrationResponse.cardBrands.indexOf('PAYPAL') > -1) {
                registrationResponse.cardBrands = registrationResponse.cardBrands.replace('PAYPAL', '');
            }
            payvisionForm.setAttribute('data-brands',
            registrationResponse.cardBrands ? registrationResponse.cardBrands : 'VISA MASTER AMEX');
            document.body.appendChild(payvisionForm);
            window['wpwlOptions'] = window['wpwlOptions'] || {};
            jQuery('form.paymentWidgets').appendTo('#pvscript');
        }
    }
    getOrderTypeId(): number{
        if(this.paymentComponentSettings.memberTypeId && (this.paymentComponentSettings.memberTypeId ===MemberTypeEnum.DISTRIBUTOR || 
            this.paymentComponentSettings.memberTypeId ===MemberTypeEnum.FPC)){
                return PurchaseFlow.Personal_Order;
            }else{
                return PurchaseFlow.Retail;
            }
           
    }
    
    /**
     * @description mapping payvision options
     * here we used any type
     * @date 2018-08-27
     * @private
     * @returns {*}
     * @memberof PayvisionComponent
     */
    private getPayvisionOptions(): any {
        // Reason we any Type here is we dont have chance
        // to write to interface for payvison object
        const payvisionOptions: any = {
            maskCvv: true,
            billingAddress: this.mapBillingAddress(),
            mandatoryBillingFields: this.getBillingAddressManadatoryFields()
        };
        const payvisionComponent = this;
        payvisionOptions['onReady'] = function () {
            $('.wpwl-button-pay').html('Continue').addClass('btn blue-button col col-sm-auto');
            // tslint:disable-next-line:max-line-length
            $('iframe').attr('sandbox', 'allow-forms allow-popups allow-pointer-lock allow-same-origin allow-scripts allow-top-navigation-by-user-activation allow-top-navigation');
        };
        payvisionOptions['onReadyIframeCommunication'] = function () {
            payvisionComponent.zone.run(() => {
                setTimeout(() => {
                    payvisionComponent.paymentComponentSettings.payvisionFormLoaded = true;
                }, 0);
            });
        };
        return payvisionOptions;
    }
    /**
     * @description mapping the billing address in the
     * payvision payment form
     * @date 2018-08-31
     * @private
     * @returns {PayvisionBillingAddress}
     * @memberof PayvisionComponent
     */
    private mapBillingAddress(): PayvisionBillingAddress {
        const countryCode =this.paymentComponentSettings.billingAddress && this.paymentComponentSettings.billingAddress.countryCodeTwo 
                     ?  this.paymentComponentSettings.billingAddress.countryCodeTwo : '';
        const billingAddress: PayvisionBillingAddress = {
            country: countryCode ? countryCode : (this.paymentComponentSettings.isoTwoletterCountryCode 
                ? this.paymentComponentSettings.isoTwoletterCountryCode : ''),
            city: (this.paymentComponentSettings.billingAddress && this.paymentComponentSettings.billingAddress.city)
             ? this.paymentComponentSettings.billingAddress.city.toString() : '',
            state: (this.paymentComponentSettings.billingAddress && this.paymentComponentSettings.billingAddress.stateId)
            ? this.states.find(x => x.id === this.paymentComponentSettings.billingAddress.stateId).stateCode : '',
            postcode: (this.paymentComponentSettings.billingAddress &&  this.paymentComponentSettings.billingAddress.zipCode)
             ? this.paymentComponentSettings.billingAddress.zipCode.toString() : '',
            street1: (this.paymentComponentSettings.billingAddress &&  this.paymentComponentSettings.billingAddress.addressLine1)
             ? this.paymentComponentSettings.billingAddress.addressLine1.toString() : '',
            street2: (this.paymentComponentSettings.billingAddress &&  this.paymentComponentSettings.billingAddress.addressLine2)
             ? this.paymentComponentSettings.billingAddress.addressLine2.toString() : '',
        };
        return billingAddress;
    }
    /**
     * @description to get payvision mandatory fields
     *  in payment form
     * @date 2018-07-27
     * @private
     * @returns {PayvisionMandatoryBillingAddressFields}
     * @memberof PayvisionComponent
     */
    private getBillingAddressManadatoryFields(): PayvisionMandatoryBillingAddressFields {
        const mandatoryBillingFields: PayvisionMandatoryBillingAddressFields = {
            country: true,
            state: true,
            city: true,
            postcode: true,
            street1: true,
            street2: false
        };
        return mandatoryBillingFields;
    }
}



// WEBPACK FOOTER //
// ./src/app/customerservice/components/payments/payvision.component.ts